import type { CSVBulkAccountVM } from 'ab-viewModels/account/upload.viewModel';

import { AccountPermission } from '@acceligentllc/shared/enums/accountPermission';
import { AccountPermissionTemplate } from '@acceligentllc/shared/enums/accountPermissionTemplate';
import { AccountPermissionTemplateOptions } from '@acceligentllc/shared/enums/accountPermissionTemplateOptions';

export class BulkAccountFM {
	accounts: AccountFM[];
	message: string | undefined;

	static toFormModel(model: CSVBulkAccountVM['valid']): BulkAccountFM {
		return {
			accounts: model.map(AccountFM.toFormModel),
			message: undefined,
		};
	}
}

class AccountFM {
	email: Nullable<string>;
	phoneNumber: Nullable<string>;
	uniqueId: string;
	firstName: string;
	lastName: string;
	assignableToWorkOrder: boolean;
	assignableAsSuperintendent: boolean;
	assignableAsProjectManager: boolean;
	assignableAsQAQC: boolean;
	assignableAsAccounting: boolean;
	assignableAsManagement: boolean;
	assignableAsTechnician: boolean;
	excludeFromNotifyAll: boolean;
	activateImmediately: boolean;
	activeInLMS: boolean;
	shouldSendEmailInvite: boolean;
	shouldSendPhoneInvite: boolean;
	accountTemplateId: AccountPermissionTemplate;
	accountTemplate: typeof AccountPermissionTemplateOptions[0] | null;
	permissions: Record<AccountPermission, boolean>;

	static toFormModel(model: CSVBulkAccountVM['valid'][number]): AccountFM {
		return {
			email: model.email,
			phoneNumber: model.phoneNumber,
			uniqueId: model.uniqueId,
			firstName: model.firstName,
			lastName: model.lastName,
			assignableToWorkOrder: true,
			assignableAsSuperintendent: false,
			assignableAsProjectManager: false,
			assignableAsQAQC: false,
			assignableAsAccounting: false,
			assignableAsManagement: false,
			assignableAsTechnician: false,
			excludeFromNotifyAll: false,
			activateImmediately: false,
			activeInLMS: true,
			shouldSendEmailInvite: false,
			shouldSendPhoneInvite: false,
			accountTemplateId: AccountPermissionTemplate.FIELD_WORKER,
			accountTemplate: AccountPermissionTemplateOptions.find((_option) => _option.id === AccountPermissionTemplate.FIELD_WORKER) ?? null,
			permissions: Object.keys(AccountPermission).reduce(AccountFM.reducePermissions, {} as Record<AccountPermission, boolean>),
		};
	}

	static reducePermissions(acc: Record<AccountPermission, boolean>, permission: AccountPermission) {
		acc[AccountPermission[permission]] = permission === AccountPermission.FR_FILL;
		return acc;
	}
}
